import { frag, el } from './dom';
import type { TokenizationResult } from '../tokenize/types';
import { pricing } from '../data/pricing';

export interface PanelOptions {
  showIds: boolean;
  premium?: number | null;
  oerePerCall?: number | null;
}

export function renderPanel(root: HTMLElement, result: TokenizationResult, opts: PanelOptions): void {
  const meta = pricing[result.encoding];
  root.classList.add('ow-panel');
  const tpl = `
    <div class="ow-panel-head">
      <div class="ow-panel-id"></div>
      <div class="ow-panel-meta"></div>
    </div>
    <div class="ow-panel-text" data-encoding="${result.encoding}"></div>
    <div class="ow-panel-tokens"></div>
  `;
  root.replaceChildren(frag(tpl));
  root.querySelector<HTMLElement>('.ow-panel-id')!.textContent = result.encoding;
  root.querySelector<HTMLElement>('.ow-panel-meta')!.textContent = `${meta.modelLabel} · ${meta.era}`;
  root.querySelector<HTMLElement>('.ow-panel-tokens')!.textContent = `${result.totalTokens} tokens`;

  const target = root.querySelector<HTMLElement>('.ow-panel-text')!;
  result.tokens.forEach((t, i) => {
    const span = el('span', {
      class: `ow-tok ow-tok-${i % 6}`,
      text: opts.showIds ? String(t.id) : t.text,
      attrs: {
        'data-cstart': String(t.cstart),
        'data-cend': String(t.cend),
        'data-id': String(t.id)
      }
    });
    if (opts.showIds) span.classList.add('ow-tok-ids');
    target.appendChild(span);
  });

  if (opts.premium != null) {
    // Premium can be 0, positive, or rarely negative (if user types EN-leaning text).
    // Render a literal `+` prefix only for strictly-positive values; the sign on
    // negative numbers is part of the toString already.
    const sign = opts.premium > 0 ? '+' : '';
    const premiumWrap = el('div', { class: 'ow-panel-premium' });
    premiumWrap.appendChild(el('div', {
      class: 'ow-panel-premium-num', text: `${sign}${opts.premium} %`
    }));
    premiumWrap.appendChild(el('div', {
      class: 'ow-panel-premium-cap', text: 'vs. engelsk'
    }));
    root.appendChild(premiumWrap);
  }
  if (opts.oerePerCall != null) {
    root.appendChild(el('div', {
      class: 'ow-panel-cost',
      text: `${opts.oerePerCall.toFixed(2).replace('.', ',')} øre`
    }));
  }
}
